'use strict'

'use strict';

var videojs = require('video.js');
require('es6-promise/auto')

function init() {
	var mastheadVideo = document.getElementById('mastheadVideo');
	if (!mastheadVideo) return;

	function get(url) {
		return new Promise(function(resolve, reject) {
			var xhr = new XMLHttpRequest;
			xhr.open('GET', url);
			xhr.onload = function() {
				if (xhr.status === 200) {
					resolve(xhr.responseText);
				} else {
					reject(Error(xhr.statusText))
				}
			};
			xhr.onerror = function() {
				reject(Error('Network Error'));
			};
			xhr.send();
		});
	}

	var jsonUrl = mastheadVideo.getAttribute('data-json');
	var options = {
		preload: 'auto',
		loop: true,
		autoplay: true,
		mute: true,
		controls: false,
		sources: []
	};

	get(jsonUrl)
		.then(function(result) {
			return JSON.parse(result).gfyItem;
		}).then(function(response) {
			if (response.webmUrl) {
				options.sources.push({
					src: response.webmUrl,
					type: 'video/webm'
				});
			}
			if (response.mp4Url) {
				options.sources.push({
					src: response.mp4Url,
					type: 'video/mp4'
				});
			}
			var player = videojs(mastheadVideo, options);
		}).catch(function(error) {
			console.warn('The masthead video could not be loaded.');
		});
}

// function init() {
// 	var elem = document.querySelector('#mastheadVideo');

// 	if (elem === null) return;

// 	var videoUrl = elem.getAttribute('data-url');
// 	var videoOptions = {
// 		url : videoUrl,
// 		autoplay : false,
// 		loop : true,
// 		byline : false,
// 		title : false,
// 		responsive : true
// 	}
// 	var player = new VimeoPlayer('mastheadVideo', videoOptions);
// 	player.setVolume(0);
// 	player.on('loaded', function() {
// 		player.play();
// 		if (elem.classList) {
// 			elem.classList.add('loaded');
// 		} else {
// 			elem.className += ' loaded';
// 		}
// 	});
// }

module.exports = {
	init : init
};
